import {ProjectFeatureFlag} from 'common/report/constants';
import type {CurrentProject} from 'common/report/model-resources/projects';
import {FeatureRollouts} from 'common/report/util/feature-sampling';

import {SupportPlanTier} from './types';

// TODO potentially get these from the same place we specify rollouts
const FEATURES_TO_INCLUDE = [ProjectFeatureFlag.DataTableVirtualized, ProjectFeatureFlag.ValueComparison];

export function getSupportPlanTier(totalArr: number): SupportPlanTier {
  let tier = SupportPlanTier.Free;
  if (totalArr >= 350_000) {
    tier = SupportPlanTier.Strategic;
  } else if (totalArr >= 100_000) {
    tier = SupportPlanTier.Tier1;
  } else if (totalArr >= 50_000) {
    tier = SupportPlanTier.Tier2;
  } else if (totalArr >= 10_000) {
    tier = SupportPlanTier.Enterprise;
  } else if (totalArr > 0) {
    tier = SupportPlanTier.Growth;
  }
  return tier;
}

export function getSpecialFeaturesForProject(project: CurrentProject): string[] {
  const featureFlagFeatures = FEATURES_TO_INCLUDE.filter((feature) => project?.hasFeatureFlag(feature));
  const rolloutFeatures = Object.values(FeatureRollouts)
    .filter((rollout) => rollout.isEnabled(project))
    .map((rollout) => rollout.name.toString());

  return [...featureFlagFeatures, ...rolloutFeatures];
}
